import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { DOCS } from '@constants/routes';

const OverviewPage = lazy(
  () => import('@features/docs/pages/overview/Overview')
);
const APIReference = lazy(
  () => import('@features/docs/pages/api-reference/ApiReference')
);
const ApiKeys = lazy(() => import('@features/docs/pages/api-keys/ApiKeys'));
const Webhooks = lazy(() => import('@features/docs/pages/webhooks/Webhooks'));

export const DocsRoutes: RouteObject[] = [
  {
    path: DOCS.OVERVIEW,
    element: <OverviewPage />
  },
  {
    path: DOCS.API_KEYS,
    element: <ApiKeys />
  },
  {
    path: DOCS.WEBHOOKS,
    element: <Webhooks />
  },
  {
    path: DOCS.API_REFERENCE,
    element: <APIReference />
  }
];

export default DocsRoutes;
